/**
 * Het sterretje achter een verplichte vraag in de open vragenlijst.
 *
 * Waarom niet alleen een `*`: voor een schermlezer is een sterretje geen
 * betekenis. De uitleg staat er daarom uitgeschreven bij, verborgen voor het
 * oog (dezelfde `.matrix-cell-label`-aanpak: wél in de boom, geen ruimte).
 *
 * Alleen een echte boolean telt. Vlaggen worden in deze database in twee vormen
 * bewaard — boolean én de tekst 'true'/'false' — en de tekst 'false' is
 * truthy. Dit veld is nieuw en gebruikt de boolean, net als `MatrixBipolar`.
 * AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches
 *
 * Dit sterretje wordt door twee schermen getekend (de losse vraag en de sectie).
 * Wie hier een markering bijzet die gedrag belooft, moet élke ouder van dit
 * component nalopen — anders staat het teken er wel en werkt de regel niet.
 * AI-CONTEXT: See docs/pitfalls.md#ui-shared-affordance-gated-per-caller
 *
 * @param {object} props
 * @param {*} [props.required] - De `Required`-waarde van het veld
 * @param {string} [props.label] - Vertaalde uitleg; standaard 'Verplichte vraag'
 */
const RequiredMark = ({ required, label }) => {
    if (required !== true) return null;

    return (
        <span className='qo-required-mark'>
            <span aria-hidden='true'>*</span>
            <span className='qo-visually-hidden'>{label || 'Verplichte vraag'}</span>
        </span>
    );
};

export default RequiredMark;
